import { render, staticRenderFns } from "./WindowCardLayout.vue?vue&type=template&id=c86318f8&scoped=true"
import script from "./WindowCardLayout.vue?vue&type=script&lang=js"
export * from "./WindowCardLayout.vue?vue&type=script&lang=js"
import style0 from "./WindowCardLayout.vue?vue&type=style&index=0&id=c86318f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86318f8",
  null
  
)

export default component.exports